import { render, staticRenderFns } from "./roomDetails.vue?vue&type=template&id=3738c779&scoped=true"
import script from "./roomDetails.vue?vue&type=script&lang=js"
export * from "./roomDetails.vue?vue&type=script&lang=js"
import style0 from "./roomDetails.vue?vue&type=style&index=0&id=3738c779&prod&lang=less&scoped=true"
import style1 from "./roomDetails.vue?vue&type=style&index=1&id=3738c779&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3738c779",
  null
  
)

export default component.exports